export default __webpack_public_path__ + "images/3a02b75f83fee2c4485466ae9a9bf144-acoustic_small.webp";